import { render, staticRenderFns } from "./collections.vue?vue&type=template&id=20ab5d5d"
import script from "./collections.vue?vue&type=script&lang=js"
export * from "./collections.vue?vue&type=script&lang=js"
import style0 from "./collections.vue?vue&type=style&index=0&id=20ab5d5d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports